export enum EmailFormType {
    EmailFormByGroup,
    EmailFormByMember,
    EmailFormByExternal
}